import { blue } from "@mui/material/colors";
import { Typography } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";

function LoginSlider({ data = [] }) {
  const [current, setCurrent] = useState(0);
  const [visible, setVisible] = useState(true);
  const timerRef = useRef(null);

  const goTo = (index) => {
    setVisible(false);
    setTimeout(() => {
      setCurrent(index);
      setVisible(true);
    }, 200);
  };

  useEffect(() => {
    if (data.length <= 1) return;
    timerRef.current = setInterval(() => {
      goTo((current + 1) % data.length);
    }, 3000);
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.length, current]);

  if (!data.length) return null;

  const item = data[current];

  return (
    <div className="text-center">
      <img
        src={item.image}
        alt={item.title}
        className="img-fluid"
        style={{
          width: "100%",
          height: "700px",
          maxHeight: "90%",
          objectFit: "contain",
          opacity: visible ? 1 : 0,
          transition: "opacity 0.2s ease-in-out",
        }}
      />

      {data.length > 1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 10,
            marginTop: -20,
          }}
        >
          {data.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              style={{
                width: 17,
                height: 17,
                borderRadius: "var(--radius-round)",
                border: "none",
                padding: 0,
                cursor: "pointer",
                background:
                  i === current
                    ? `var(--primary-base, ${blue[700]})`
                    : "var(--neutral-200)",
              }}
            />
          ))}
        </div>
      )}
      <Typography
        variant="h6"
        component="h2"
        className="text-center fs-14 mt-3"
        style={{
          opacity: visible ? 1 : 0,
          transition: "opacity 0.3s ease-in-out",
        }}
      >
        {item?.title || ""}
      </Typography>
    </div>
  );
}

export default LoginSlider;
